import gql from 'graphql-tag';

const mutation = gql`
  mutation InitiateChat($params: InitiateChatParams!) {
    initiateChat(params: $params)
  }
`;

export default mutation;
